<template>
  <div :class="containerClasses">
    <slot />
  </div>
</template>

<script>
import { computed, defineComponent } from 'vue'

export default defineComponent({
  /**
   * @type {String}
   * @description This is the name of the component this will also
   * be the tag name of the component to use in templates
   * @example
   * <ak-app-container />
   */
  name: 'AkBasicContainer',

  /**
   * @type {Boolean}
   * @description This prevents all element attributes that are not
   * defined in the props object from being applied to the rendered
   * component root element, the exception to this is "class" all
   * of the given classes would be merged with the component
   * defined ones.
   */

  setup() {
    /**
     * @returns {Object}
     * @description Returns the classes for the root element of the
     * basic component.
     */
    const containerClasses = computed(() => {
      return {
        'content-container': true,
        'content-container--show-scrollbar': true,
        'overflow--webkit-touch': true,
        'one-whole': true,
        'bg-grey-lightest': true,
        'h-full': true,
        flex: true,
        'flex--column': true,
      }
    })

    return {
      containerClasses,
    }
  },
})
</script>
